var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconHistory = function SvgIconHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.882 2.823.062.004c4.97.094 8.98 4.188 8.98 9.174 0 5.052-4.112 9.176-9.157 9.176-4.748 0-8.708-3.63-9.118-8.31l-.006-.073h-1.72l2.883-4.795 2.884 4.794H5.913c.363 3.482 3.318 6.122 6.886 6.122 3.796 0 6.921-3.135 6.921-6.938 0-3.635-2.963-6.713-6.517-6.883l-.223-.007c-.808-.014-1.168-.429-1.168-1.133 0-.591.394-1.064.949-1.125l.121-.006zm.533 3.902c.499 0 .919.391.981.902l.007.113v5.074c0 .21-.064.41-.193.59l-.08.097-.064.072-2.55 2.549c-.416.42-1.11.42-1.508-.003a1.09 1.09 0 0 1-.083-1.404l.087-.1 2.25-2.246V7.74c0-.504.367-.94.868-1.007l.113-.007h.172z",
    fill: "#FA5851",
    fillRule: "evenodd"
  })));
};

export default SvgIconHistory;